import React from 'react'
import './loginUiComponent.css';
import { Navigate } from 'react-router-dom';

import logoPage from '../../assets/image/png/Salescodewhitelogo.png';
import loginVideo from '../../assets/video/animation.mp4';
import { DashboardPopup } from '../popup/dashboardPopup';

export default function LoginUiComponent(props:any) {
    const isRefreshTokenEnabled = localStorage.getItem("refreshToken") === "verified";
    const token:string | null =  isRefreshTokenEnabled ? sessionStorage.getItem("access_token") : localStorage.getItem("access_token");
    return (
        <div className='login-container'>
            {((token || isRefreshTokenEnabled) && !props.allow) && 	
                <Navigate to="/dashboard" />
            }
            {( !token || props.allow===true)  &&
                <>
                    <DashboardPopup />
                    <div className='login-form-container'  style={props?.loginUIConfig?.backgroundColor ? { background: props?.loginUIConfig?.backgroundColor } : {}}>
                        <div className="login-form-center">
                        <div className='login-page-logo'  style={props?.loginUIConfig ? { width:"20%" , marginBottom:"30px"} : {}}>
                            {props?.loginUIConfig?.logo ? <img alt='company logo' src={props?.loginUIConfig?.logo} height="auto" width="100%" /> :
                                <img alt='company logo' src={logoPage} height="auto" width="100%" />}
                        </div>
                            {props.children}
                        </div>
                    </div>
                    <div className='login-about-container'>
                        <video id="login-about-video" autoPlay muted loop >
                            <source src={loginVideo} type="video/mp4" />
                        </video>
                    </div>
                </>
            }
        </div>
    );
}
